import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import { Park } from "types/Park";

const processOptions = (options: Park[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function ParkSelect(props: any) {
  return (
    <RemoteSelect url="parks" processOptions={processOptions} {...props} />
  );
}

export default ParkSelect;
